<template>
  <div class="bid-detail"  v-loading.fullscreen.lock="fullscreenLoading">
    <div class="bid-detail-info">
      <div class="my-position">
        <div class="youposition">您的位置:</div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/' }">竞采</el-breadcrumb-item>
          <el-breadcrumb-item>竞采详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="bid-list">
        <ul class="clearfix bid-list-ul">
          <li>
            <div>
              <div class="bid-img-box">
                <img v-if="formRow.ProductImg" style="width: 100%;" :src="ProductImg" alt="">
                <p v-if="!formRow.ProductImg" style="font-size: 16px;font-weight: 600;color: #ffffff;text-align: center;line-height: 298px" >暂无图片</p>
                <div class="absolute-status" :class="{'successStatus':formRow.State == 2}">
                  <p v-if="formRow.State == 0">待发布</p>
                  <p v-if="formRow.State == 1">未开始</p>
                  <p v-if="formRow.State == 2">已开始</p>
                  <p v-if="formRow.State == 3">已完成</p>
                </div>
              </div>
              <p class="bid-code">
                商品编号：{{ Id }}
              </p>
            </div>
            <div class="bid-info">
              <div class="bin-info-title">
                <div><img src="/static/images/bid/bidbuy_biao.png"></div>
                <span>{{ formRow.ProductName }}</span>
              </div>
              <p v-if="formRow.Status">
                <i class="sub-icon menu-icon ogc-icon-font ogc-icon-jiagebaohu"></i>
                <span class="span-label">起拍价：</span><span class="span-value">￥{{formRow.StartPrice}}/吨</span>
              </p>
              <!--<p>-->
                <!--<i class="sub-icon menu-icon ogc-icon-font ogc-icon-jiagebaohu"></i>-->
                <!--<span class="span-label">：</span><span class="span-value">￥{{formBid.CurrentMinPrice}}/吨</span>-->
              <!--</p>-->
              <p>
                <i class="el-icon-shopping-cart-2"></i>
                <span class="span-label">竞采量：</span><span class="span-value">{{parseFloat(formRow.AuctionNum).toFixed(2)}}吨</span>
              </p>
              <p>
                <i class="el-icon-postcard"></i>
                <span class="span-label">出价方式：</span><span class="span-value">{{formRow.PriceType == 1?'公开报价':formRow.PriceType == 2?'封闭报价':'竞采者封闭报价'}}</span>
              </p>
              <p>
                <i class="el-icon-timer"></i>
                <span class="span-label">起始时间：</span><span class="span-value">{{formRow.AutionStartTime?formRow.AutionStartTime.replace(/T/,' '):''}} — {{formRow.AutionEndTime?formRow.AutionEndTime.replace(/T/,' '):''}}</span>
              </p>
              <p>
                <i class="el-icon-timer"></i>
                <span class="span-label">交货截止日期：</span><span class="span-value">{{formRow.F_ShipmentDate}}</span>
              </p>
              <p>
                <i class="el-icon-timer"></i>
                <span class="span-label" style="width: 95px;">{{formRow.State == 1?'开始':formRow.State == 2?'结束':''}}倒计时：</span><span class="span-value" style="color: red;">{{timeStr}}</span>
              </p>
              <button class="join-button" v-if="formRow.State != 3" @click="toBid">{{formRow.Status?'出价':'参与'}}</button>
              <!--<button class="join-button" @click="toBid">{{formRow.Status?'出价':'参与'}}</button>-->
            </div>
            <div class="bid-button-father" style="">
              <div style="margin-bottom: 5px;">
                <el-alert
                  :title="'温馨提示：'+mesRight"
                  type="error"
                  effect="dark">
                </el-alert>
              </div>
              <el-table
                :data="MyPriceList"
                class="table-sty"
                height="160px"
                v-loading="tableLoading"
                border
                :cell-style="cellStyleFun"
                size="small"
              >
                <el-table-column
                  prop="CreateTime"
                  header-align="center" align="center"
                  label="出价时间"
                  width="180">
                  <template slot-scope="scope">
                    <P>{{scope.row.CreateTime.replace(/T/,' ')}}</P>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="AutionPrice"
                  header-align="center" align="center"
                  label="出价(元/吨)"
                  width="">
                </el-table-column>
                <el-table-column
                  prop="FirstQuantity"
                  header-align="center" align="center"
                  label="竞采数量(吨)"
                  width="">
                </el-table-column>
                <!--<el-table-column-->
                  <!--prop="AutionQuantity"-->
                  <!--header-align="center" align="center"-->
                  <!--label="有效数量(吨)"-->
                  <!--width="">-->
                <!--</el-table-column>-->
              </el-table>
              <p v-if="(formRow.State == 0 || formRow.State == 1 || formRow.State==2) && formRow.AutionModel != 1 && formRow.Status" style="font-size: 15px;color: red;font-weight: 600;margin-top: 10px;">当前最低价：{{formBid.CurrentMinPrice}}元/吨</p>
            </div>
            <el-link class="bid-button-top" @click="reLoad"><i class="el-icon-refresh-left"></i>刷新</el-link>
          </li>
        </ul>
      </div>
    </div>
    <div class="bid-tabs">

      <el-tabs v-if="formRow.State == 3" class="tabs-box" v-model="activeNameZb" type="card" @tab-click="handleClick('second')">
        <el-tab-pane label="当前中标" name="second">
          <div class="all-bid">
            <el-table
              :data="CurrentPriceList"
              class="table-sty"
              v-loading="tableLoading"
              style="width: 80%">

              <el-table-column
                prop="SuccessPrice"
                header-align="center" align="center"
                label="中标价格(元/吨)">
              </el-table-column>
              <el-table-column
                prop="AutionQuantity"
                header-align="center" align="center"
                label="中标量(吨)">
              </el-table-column>
              <el-table-column
                prop="WinType"
                header-align="center" align="center"
                label="状态">
                <template slot-scope="scope">
                  {{scope.row.WinType==1?'已中标':scope.row.WinType==2?'公示中':'未中标'}}
                </template>
              </el-table-column>
              <el-table-column
                header-align="center" align="center"
                label="操作">
                <template slot-scope="scope">
                  <!--<el-button type="text" @click="creatOrder(scope.row)">支付</el-button>-->
                  <el-button type="text" @click="onPrinter(scope.row)">通知单</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
      </el-tabs>

      <div style="border-top: 30px solid #f5f5f5;">
        <el-tabs class="tabs-box tabs-box1" v-model="activeBottom" type="card" @tab-click="handleClickCh">

          <el-tab-pane label="产品介绍" name="second">
            <div style="font-size: 14px" v-html="formRow.ProductDetailTexts">

            </div>
          </el-tab-pane>
        </el-tabs>
        <div class="bid-process">
          <div>
            <!--<img style="width:100%;" src="/static/images/bid/lccg.png">-->
          </div>
        </div>
      </div>

    </div>
    <el-dialog
      :title="'拼盘号：'+Id"
      :visible.sync="centerDialogVisible"
      :close-on-click-modal="false"
      width="900px"
      center>
      <p style="font-size: 14px;margin-bottom: 10px;"><span>倒计时</span>：<span style="color: red;font-weight: 600">{{timeStr}}</span></p>
      <el-form size="mini" :inline="true" class="dialog-form-display">
        <el-col :span="12">
          <el-form-item label="竞采产品：">
            <span>{{BidRow.ProductName}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="起拍价：">
            <span><span class="s-value">{{parseFloat(BidRow.StartPrice).toFixed(2)}}</span>元/吨</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="最少交易数量：">
            <span><span class="s-value">{{parseFloat(BidRow.StartWeight).toFixed(2)}}</span>吨</span>
          </el-form-item>
        </el-col>
        <!--油e购这块还需要解开注释-->
        <!--<el-col :span="12">-->
        <!--<el-form-item label="最小交易单位：">-->
        <!--<span><span class="s-value">{{parseFloat(BidRow.StartUnit).toFixed(2)}}</span>吨</span>-->
        <!--</el-form-item>-->
        <!--</el-col>-->
        <!--<el-col :span="12">-->
        <!--<el-form-item label="当前最低价：">-->
        <!--<span><span class="s-value">{{parseFloat(BidRow.CurrentMinPrice).toFixed(2)}}</span>元/吨</span>-->
        <!--</el-form-item>-->
        <!--</el-col>-->
        <el-col :span="12">
          <el-form-item label="竞采量：">
            <span><span class="s-value">{{parseFloat(BidRow.AuctionNum).toFixed(2)}}</span>吨</span>
          </el-form-item>

        </el-col>

        <el-col :span="12">
          <el-form-item label="减价梯度：">
            <span><span class="s-value">{{parseFloat(BidRow.AddPrice).toFixed(2)}}</span>元/吨</span>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="我的中标：">
            <span><span class="s-value">{{BidRow.MyAuctionQuantity? parseFloat(BidRow.MyAuctionQuantity).toFixed(2):0.00}}</span>吨</span>
          </el-form-item>
        </el-col>
      </el-form>
      <el-form ref="formBid" :rules="rules" size="mini" :inline="true" label-width="130px" label-position="right" :model="formBid">
        <el-col :span="12">
          <el-form-item label="竞采数量：" prop="AuctionNum">
            <!--<el-input type="number" :min="0" style="width: 140px;" placeholder="" v-model="formBid.AuctionNum">-->
            <!--<template slot="append">吨</template>-->
            <!--</el-input>-->
            <span @click="stepInNum" style="display:inline-block;width: 30px;line-height: 26px;border: 0px;background: #F5F7FA;cursor: pointer;text-align: center">-</span>
            <input v-model="formBid.AuctionNum" class="inputaddsty" style="width: 100px;border: 1px solid #ddd;border-radius: 3px;padding: 0px 8px;line-height: 26px"/>
            <span @click="stepAddNum" style="display:inline-block;width: 30px;line-height: 26px;border: 0px;background: #F5F7FA;cursor: pointer;text-align: center">+</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="竞采出价：" prop="AuctionPrice">
            <span @click="stepIn" style="display:inline-block;width: 30px;line-height: 28px;border: 0px;background: #F5F7FA;cursor: pointer;text-align: center">-</span>
            <input v-model="formBid.AuctionPrice" class="inputaddsty" readonly style="width: 100px;border: 1px solid #ddd;border-radius: 3px;padding: 0px 8px;line-height: 28px"/>
            <span @click="stepAdd" style="display:inline-block;width: 30px;line-height: 28px;border: 0px;background: #F5F7FA;cursor: pointer;text-align: center">+</span>
            <!--<el-input-number @focus="noIput" :min="formBid.CurrentMinPrice" style="width: 140px;" readonly="true" v-model="formBid.AuctionPrice" :step="formBid.AddPrice"></el-input-number>-->
          </el-form-item>

        </el-col>
        <el-col :span="12">
          <el-form-item label="总出价：">
            <el-input style="width: 160px" :disabled="true" placeholder="" v-model="AllMoney">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
        </el-col>
        <!--<el-col :span="12">-->
          <!--<el-form-item label="最高价：">-->
            <!--<el-input style="width: 160px" :disabled="true" placeholder="" v-model="formBid.CurrentMaxPrice">-->
              <!--<template slot="append">元/吨</template>-->
            <!--</el-input>-->
          <!--</el-form-item>-->
        <!--</el-col>-->
        <el-col :span="12">
          <el-form-item label="交货截止时间：" prop="DeliverEndTime">
            <el-date-picker
              v-model="formBid.DeliverEndTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期时间">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="可供最大量：" prop="Remark">
            <el-input  placeholder="可供最大量" v-model="formBid.Remark">
              <template slot="append">吨</template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="centerDialogVisible = false">取 消</el-button>
          <el-button size="mini" type="primary" :loading="outPriceFlag" @click="outPrice">出 价</el-button>
          <el-button size="mini" icon="el-icon-refresh-right" :loading="refreshPriceFlag" type="danger" @click="refreshData">刷 新</el-button>
        </span>
    </el-dialog>
    <el-dialog
      title="选择参与企业"
      :visible.sync="centerDialogVisible1"
      :close-on-click-modal="false"
      width="400px"
      center>

      <el-form ref="formJoin" :rules="rules" size="mini" :inline="true" label-width="100px" label-position="left" :model="formJoin">

        <el-col :span="24">
          <el-form-item label="选择企业：" prop="CompanyId">
            <el-select style="width: 100%;" v-model="formJoin.CompanyId" filterable placeholder="请选择">
              <el-option
                v-for="item in companyArr"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="centerDialogVisible1 = false">取 消</el-button>
          <el-button size="mini" type="primary" :loading="outPriceFlag" @click="toJoin">参 与</el-button>
        </span>
    </el-dialog>


    <el-dialog
      title="打印通知单"
      :visible.sync="printerDialog"
      :close-on-click-modal="false"
      center>
      <div id="printNotes">
        <div>
          <p class="title-p" style="margin-bottom: 10px;">{{pinInfo.SalerCompanyName}}</p>
          <P style="text-align: center;font-size: 14px;">{{pinInfo.Address}}</P>
          <P style="text-align: center;font-size: 14px;margin-bottom: 15px;margin-top: 10px;">{{pinInfo.LinkTel}}</P>
        </div>
        <div>
          <p class="title-p">{{printMeObj.popTitle}}</p>
        </div>
        <div class="info-box">
          <el-row :gutter="20">
            <el-col :span="12"><div class="info-flex"><p>公 司：</p><span>{{pinInfo.CompanyName}}</span></div></el-col>
            <el-col :span="12"><div class="info-flex"><p>联系人：</p><span>{{pinInfo.CompanyLinkUser}}</span></div></el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12"><div class="info-flex"><p>电 话：</p><span>{{pinInfo.CompanyTel}}</span></div></el-col>
            <el-col :span="12"><div class="info-flex"><p>地 址：</p><span>{{pinInfo.CompanyAddr}}</span></div></el-col>
          </el-row>
        </div>
        <div style="margin-top: 20px;">
          <div class="detail-head">
            <div>产品名称</div>
            <div>单位</div>
            <div>中标数量</div>
            <div>中标价格</div>
            <div>总金额</div>
          </div>
          <div class="detail-body" v-for="(item,index) in pinInfo.list" :key="index">
            <div>{{item.ProductName}}</div>
            <div>{{item.Unit}}</div>
            <div>{{item.AutionQuantity}}</div>
            <div>{{item.SucessPrice}}</div>
            <div>{{item.Amount}}</div>
          </div>
          <!--<el-table-->
          <!--:data="pinInfo.list"-->
          <!--border-->
          <!--&gt;-->
          <!--<el-table-column-->
          <!--prop="ProductName"-->
          <!--label="产品名称"-->

          <!--&gt;-->
          <!--</el-table-column>-->
          <!--<el-table-column-->
          <!--prop="Unit"-->
          <!--label="单位"-->
          <!--width="150px"-->
          <!--&gt;-->
          <!--</el-table-column>-->
          <!--<el-table-column-->
          <!--prop="AutionQuantity"-->
          <!--width="150px"-->
          <!--label="中标数量">-->
          <!--</el-table-column>-->
          <!--<el-table-column-->
          <!--prop="SucessPrice"-->
          <!--width="150px"-->
          <!--label="中标价格">-->
          <!--</el-table-column>-->
          <!--<el-table-column-->
          <!--prop="Amount"-->
          <!--width="120px"-->
          <!--label="总金额">-->
          <!--</el-table-column>-->
          <!--</el-table>-->
        </div>
        <div style="margin-top: 20px;">
          <p style="margin-bottom: 20px;">日 期：<span style="width: 150px;border-bottom: 1px solid #ddd;display: inline-block;padding-bottom: 10px;"></span></p>
          <p>签 字：<span style="width: 150px;border-bottom: 1px solid #ddd;display: inline-block;padding-bottom: 10px;"></span></p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="printerDialog = false">取 消</el-button>
          <el-button size="mini" type="primary" v-print="printMeObj" @click="toJoin">打 印</el-button>
        </span>
    </el-dialog>



  </div>
</template>

<script>
  import Template from "../../components/template";
  export default {
    props:{
      // Id:{
      //   type: String,
      // },
      // row:{
      //   type:Object,
      //   default: () => {}
      // }

    },
    data() {
      let isNum = (rule, value, callback) => {
        var reg2 = /^[0-9]+([.]{1}[0-9]{1,2})?$/;
        if(value == 0){
          callback(new Error('请输入大于0的数字'))
        }
        if (!reg2.test(value)) {
          callback(new Error('请输入数字'))
        }else{
          callback()
        }
      };
      let isNumNew = (rule, value, callback) => {
        var reg2 = /^[0-9]+([.]{1}[0-9]{1,2})?$/;
        if(value <this.formBid.AuctionNum){
          callback(new Error('可供最大量必须大于当前报价量！'))
        }
        if(value == 0){
          callback(new Error('请输入大于0的数字'))
        }
        if (!reg2.test(value)) {
          callback(new Error('请输入数字'))
        }else{
          callback()
        }
      };
      return {
        mesRight:'',
        MyPriceListError:[
          {
            CreateTime:'2022-06-13 10:20:03',
            AutionPrice:'4500',
            FirstQuantity:'500',
            AutionQuantity:'300'
          },
          {
            CreateTime:'2022-06-13 12:20:03',
            AutionPrice:'6000',
            FirstQuantity:'300',
            AutionQuantity:'300'
          }
        ],
        MyPriceListAll:[],
        CompanyIdPrinter:'',
        pinInfo:{
          SalerCompanyName:'神驰化工集团有限公司',
          LinkTel:'0546-8656959',
          Address:'山东省东营市东营区郝纯路129号',
          CompanyName:'北京诺伊斯特',
          CompanyAddr:'潍坊市软件园',
          CompanyTel:'0539-2306119',
          CompanyLinkUser:'Mr Song',
          list:[
            {
              ProductName:'产品1',
              Unit:'吨',
              AutionQuantity:'100',
              SucessPrice:'200',
              Amount:'22222'
            }
          ]
        },
        fullscreenLoading:false,
        printMeObj: {
          id: 'printNotes',
          popTitle: '竞采通知单',
        },
        printerDialog:false,
        activeNameZb:'second',
        IsStandard:null,
        Id:'',
        activeName:'first',
        activeNameAll:'thrid',
        tableLoading:false,
        MyPriceList:[],
        CurrentPriceList:[],
        companyArr:[],
        priceNum:'',
        activeBottom:'second',
        formRow:{},
        status:'',
        BidRow:{},
        centerDialogVisible:false,
        centerDialogVisible1:false,
        outPriceFlag:false,
        refreshPriceFlag:false,
        formBid:{
          AuctionNum:0,
          AddPrice:0,
          AuctionPrice:0,
          CurrentMinPrice:0,
          CurrentMaxPrice:0,
          CompanyId:'',
          AuctionId:'',
          DeliverEndTime:'',
          Remark:''
        },
        formJoin:{
          AuctionId:'',
          CompanyId:'',
        },
        loadingScreen:null,
        url:{
          get:SZH.assets.api + '/AuctionPurchase/GetAuctionDetailInfoForWeb',
          GetMyPriceList:SZH.assets.api + '/AuctionPurchase/GetMyPriceList',
          GetAllPriceList:SZH.assets.api + '/AuctionPurchase/GetAllPriceList',
          GetCurrentAuction:SZH.assets.api + '/AuctionPurchase/GetCurrentAuction',
          GetCurrentAuctionDetail:SZH.assets.api + '/AuctionPurchase/GetCurrentAuctionDetail',
          GetCompanyItem:SZH.assets.api + '/AuctionPurchase/GetCompanyItem',
          OfferPriceRequest:SZH.assets.api + '/AuctionPurchase/OfferPriceRequest',
          creatOrder:SZH.assets.api + '/AuctionPurchase/ToPayToCreateOrder',
          JoinInAuction:SZH.assets.api + '/AuctionPurchase/JoinInAuction',
          cuttent:SZH.assets.api + '/AuctionPurchase/GetCurrentDateTime',
          GetActionPrintForm:SZH.assets.api + '/AuctionPurchase/GetActionPrintForm',
        },
        rules:{
          AuctionNum: [
            {
              required: true,
              message: '请输入数字',
              trigger: 'blur'
            },
            {
              validator: isNum,
              trigger: 'blur'
            }
          ],
          AuctionPrice: [
            {
              required: true,
              message: '请输入数字',
              trigger: 'blur'
            },
            {
              validator: isNum,
              trigger: 'blur'
            }
          ],Remark: [
            {
              required: true,
              message: '请输入可供最大量',
              trigger: 'blur'
            },
            {
              validator: isNumNew,
              trigger: 'blur'
            }
          ],
          DeliverEndTime: [
            {
              required: true,
              message: '请选择交货截至时间',
              trigger: 'blur'
            },
          ],
        },
        timeInterval:null,
        timeStr:'',
        currentFWQTime:'',
        AllNum:0
      }
    },
    methods: {
      cellStyleFun({row, column, rowIndex, columnIndex}) {
        if(column.property == 'AutionQuantity'){
          return {color: 'red',fontWeight:600}
        }
      },
      //打印
      onPrinter(){
        let self = this;
        self.printerDialog = true;
        self.fullscreenLoading = true;
        self.$http.post(self.url.GetActionPrintForm,{
          Data:{
            CompanyId:self.CompanyIdPrinter,
            AuctionId:self.Id
          }
        }).then(result =>{
          if(result.state == true){
            self.pinInfo.SalerCompanyName = result.data.SalerCompanyName;
            self.pinInfo.LinkTel = result.data.LinkTel;
            self.pinInfo.Address = result.data.Address;
            self.pinInfo.CompanyName = result.data.company.CompanyName;
            self.pinInfo.CompanyAddr = result.data.company.CompanyAddr;
            self.pinInfo.CompanyTel = result.data.company.CompanyTel;
            self.pinInfo.CompanyLinkUser = result.data.company.CompanyLinkUser;
            self.pinInfo.list = result.data.list;
          }else{
            self.pinInfo.SalerCompanyName = '';
            self.pinInfo.LinkTel = '';
            self.pinInfo.Address = '';
            self.pinInfo.CompanyName = '';
            self.pinInfo.CompanyAddr = '';
            self.pinInfo.CompanyTel = '';
            self.pinInfo.CompanyLinkUser = '';
            self.pinInfo.list = [];
          }
          self.fullscreenLoading = false;
        }, () => {
          self.fullscreenLoading = false;
          self.$message.error('获取数据失败，请检查您的网络是否可用。');
        });
      },
      stepAdd(){
        if(this.formBid.AuctionPrice == this.formBid.CurrentMaxPrice){
          this.$message.error('出价不可高于当前最高价');
        }else{
          this.formBid.AuctionPrice = this.formBid.AuctionPrice+this.formBid.AddPrice;
        }
      },
      stepIn(){
        if(this.formBid.AuctionPrice == 0){
          this.$message.error('出价不可小于0');
        }else{
          this.formBid.AuctionPrice = this.formBid.AuctionPrice-this.formBid.AddPrice;
        }

      },
      stepAddNum(){
        this.formBid.AuctionNum = this.formBid.AuctionNum+this.BidRow.StartWeight;
      },
      stepInNum(){

        if(this.formBid.AuctionNum == this.BidRow.StartWeight){
          this.$message.error('竞采数量不得低于最小交易量！');
        }else{
          this.formBid.AuctionNum = this.formBid.AuctionNum-this.BidRow.StartWeight;
        }

      },
      getMsg(id){
        let self = this;
        self.$http.post(self.url.get,{
          Data:id
        }).then(result =>{
          if(result.state == true){

            self.formRow = result.data;
            self.status = result.data.Status;
            self.IsStandard = result.data.IsStandard;
            // self.formJoin.CompanyId = result.data.CompanyId;
            self.CompanyIdPrinter = result.data.CompanyId;
          }else{
          }
        }, () => {
          self.$message.error('获取数据失败，请检查您的网络是否可用。');
        });
      },
      getMyList(){
        let self = this;
        self.tableLoading = true;
        self.AllNum = 0;
        self.$http.post(self.url.GetMyPriceList,{
          Data:self.Id
        }).then(result =>{
          if(result.state == true && result.data.length>0){
            self.tableLoading = false;
            self.MyPriceList = result.data;
            result.data.forEach(item=>{
              self.AllNum = self.AllNum + item.AutionQuantity
            });
            self.priceNum = self.MyPriceList.length;
          }else{
            self.tableLoading = false;
            self.MyPriceList = []
          }
        }, () => {
          self.tableLoading = false;
          self.$message.error('获取数据失败，请检查您的网络是否可用。');
        });
      },
      getMyListAll(){
        let self = this;
        self.$http.post(self.url.GetAllPriceList,{
          Data:self.Id
        }).then(result =>{
          if(result.state == true && result.data.length>0){
            self.tableLoading = false;
            self.MyPriceListAll = result.data;
            self.priceNumOther = self.MyPriceListAll.length;
          }else{
            self.MyPriceListAll = [];
            self.priceNumOther = 0
          }
        }, () => {
          self.tableLoading = false;
          // self.$message.error('获取数据失败，请检查您的网络是否可用。');
        });
      },
      getCurrentList(){
        let self = this;
        self.tableLoading = true;
        self.$http.post(self.url.GetCurrentAuction,{
          Data:self.Id
        }).then(result =>{
          if(result.state == true && result.data.length>0){
            self.tableLoading = false;
            self.CurrentPriceList = result.data;
            // self.priceNum = self.MyPriceList.length;
          }else{
            self.tableLoading = false;
            self.CurrentPriceList = []
          }
        }, () => {
          // self.tableLoading = false;
          self.$message.error('获取数据失败，请检查您的网络是否可用。');
        });
      },
      handleClickNew(){
        if(this.activeName == 'first'){
          this.getMyList();
        }else{
          this.getMyListAll();
        }
      },
      handleClick(name){
        if(name == 'first'){
          this.getMyList();
        }else if(name == 'second'){
          this.getCurrentList();
        }else{
          this.getMyListAll();
        }
      },
      handleClickCh(){},
      getCompany(){
        let self = this;
        self.$http.post(self.url.GetCompanyItem,{
        }).then(result =>{
          if(result.state == true && result.data.length>0){
            self.companyArr = result.data;
            self.formJoin.CompanyId = result.data[0].value;
          }else{
            self.companyArr = [];
          }
        }, () => {
          self.$message.error('数据保存失败，请检查您的网络是否可用。');
        });
      },
      toBid(){
        let self = this;
        if(self.status){
          // self.centerDialogVisible = true;
          // self.formBid.AuctionNum = 0;
          // self.formBid.AuctionPrice = 0;
          // self.refreshData();
          if(self.formRow.State == 2){
            self.centerDialogVisible = true;
            self.formBid.AuctionNum = 0;
            self.formBid.AuctionPrice = 0;
            self.formBid.DeliverEndTime = null;
            self.formBid.Remark = null;
            self.refreshData();
          }else{
            self.$message.error('当前竞采未开始，请开始后再进行出价。');
          }

        }else{
          // self.centerDialogVisible1= true;
          self.toJoin()
        }

      },
      toJoin(){
        let self = this;
        self.formJoin.AuctionId = self.Id;
        self.outPriceFlag = true;
        self.$http.post(self.url.JoinInAuction, {Data:self.formJoin }).then(result => {
          if (result.state == true) {
            self.outPriceFlag = false;
            self.centerDialogVisible1= false;
            self.$message.success('参与成功');
            self.getMsg(self.Id);
          } else {
            self.outPriceFlag = false;
            // self.centerDialogVisible1= false;
            self.$message.error(result.message);
          }
        }, () => {
        });
      },
      outPrice(){
        let self = this;
        self.formBid.AuctionId = self.Id;
        self.formBid.CompanyId = self.formJoin.CompanyId;
        if(self.formBid.AuctionNum<self.BidRow.StartWeight){
          self.$message.error('竞采数量不能小于最小交易量!');
          return
        }
        if(self.BidRow.F_ShipmentDate<self.formBid.DeliverEndTime){
          self.$message.error('交货截止日期不能大于竞采招标规定的交货截至日期!');
          return
        }
        if(!self.formBid.DeliverEndTime){
          self.$message.error('请选择交货截至时间!');
          return
        }
        self.$confirm('确认出价吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          self.isChangePrice();
        }).catch(() => {
          self.$message({
            type: 'info',
            message: '已取消出价'
          });
        });
      },
      //判断加价梯度是不是已经改变
      isChangePrice(){
        let self = this;
        self.$http.post(self.url.GetCurrentAuctionDetail,{
          Data:self.Id
        }).then(result =>{
          if(result.state == true){
            if(self.formBid.AddPrice != result.data.AddPrice){

              self.$message.error('当前减价梯度已经改变，请重新加价后再出价！');
              self.formBid.CurrentMaxPrice = result.data.MyMinPrice;
              self.formBid.AuctionPrice = result.data.CurrentMaxPrice;
              self.formBid.CurrentMinPrice = result.data.CurrentMinPrice;//最低价
              self.formBid.AuctionNum = result.data.StartWeight;
              self.BidRow.AddPrice = result.data.AddPrice;
              self.formBid.AddPrice = result.data.AddPrice;
            }else{
              //  如果值没改变就直接 出价
              self.outPriceLast()
            }
          }else{
            self.$message.error(result.message);
          }
        }, () => {
          self.$message.error('数据获取失败，请检查您的网络是否可用。');
        });
      },
      outPriceLast(){
        let self = this;
        self.$refs['formBid'].validate(valid => {
          if (valid) {
            self.outPriceFlag = true;
            self.$http.post(self.url.OfferPriceRequest, {Data:self.formBid }).then(result => {
              if (result.state == true) {
                self.outPriceFlag = false;
                self.centerDialogVisible = false;
                self.$message.success('出价成功');
                self.reLoad();
              } else {
                self.outPriceFlag = false;
                // self.centerDialogVisible = false;
                self.$message.error(result.message);
              }
            }, () => {
            });
          }
          else {
            return false;
          }
        });
      },
      reLoad(){
        this.getMyList();
        // this.getMyListAll();
        this.getMsg(this.Id);
        this.refreshData();
      },
      refreshData(v){
        let self = this;
        self.getcuttent();
        // self.getMyListAll();
        // self.refreshPriceFlag = true;
        self.$http.post(self.url.GetCurrentAuctionDetail,{
          Data:self.Id
        }).then(result =>{
          if(result.state == 1){
            self.refreshPriceFlag = false;
            self.BidRow = result.data;
            self.formBid.CurrentMaxPrice = result.data.MyMinPrice;
            self.formBid.AuctionPrice = result.data.CurrentMinPrice;
            self.formBid.CurrentMinPrice = result.data.CurrentMinPrice;//最低价
            self.formBid.AuctionNum = result.data.StartWeight;
            self.formBid.AddPrice = result.data.AddPrice;
            var time = 0;
            if(result.data.State == 1){
              time = new Date(result.data.AutionStartTime).getTime() - new Date(self.currentFWQTime).getTime()
            }else if(result.data.State == 2){
              // time = result.Data.TaskType == 1? new Date(result.Data.AutionEndTime).getTime() - new Date(self.currentFWQTime).getTime():new Date(result.Data.DynamicEndTime).getTime() - new Date(self.currentFWQTime).getTime();
              time = result.data.TaskType == 1? new Date(result.data.AutionEndTime).getTime() - new Date(self.currentFWQTime).getTime():new Date(result.data.AutionEndTime).getTime() - new Date(self.currentFWQTime).getTime();
            }
            // var time = result.Data.TaskType == 1? new Date(result.Data.AutionEndTime).getTime() - new Date(self.currentFWQTime).getTime():new Date(result.Data.DynamicEndTime).getTime() - new Date(self.currentFWQTime).getTime();;
            if(result.data.State == 3){
              self.timeStr = '已结束';
              return
            }
            //如果时间进来就是负数直接return
            if(time<0){
              self.timeStr = '已结束';
              return;
            }
            self.formatDuring(time);
            // self.timeStr = '0 秒';
            if(self.timeInterval){
              clearInterval(self.timeInterval);
              self.timeInterval = setInterval(()=>{
                time = time-1000;
                if(time>-1000){
                  self.formatDuring(time)
                }else{
                  //未开始的时候倒计时结束刷新页面进行状态更新成为一开始

                  self.timeStr = '已结束';
                  if(!v){
                    self.getMsg(self.Id);
                    self.refreshData(true);
                  }

                  if(result.data.State == 1){

                  }else if(result.data.State == 2){
                    self.centerDialogVisible = false;
                    location.reload();
                  }
                  clearInterval(self.timeInterval);
                }
              },1000)
            }else{
              self.timeInterval = setInterval(()=>{
                time = time-1000;
                if(time>-1000){
                  self.formatDuring(time);
                }else{
                  self.timeStr = '已结束';
                  if(!v){
                    self.getMsg(self.Id);
                    self.refreshData(true);
                  }
                  // self.refreshData(true);
                  if(result.data.State == 1){

                  }else if(result.data.State == 2){
                    self.centerDialogVisible = false;
                    location.reload();
                  }
                  clearInterval(self.timeInterval);
                  // self.dialogVisible = true;
                }
              },1000)
            }


          }else{
            self.refreshPriceFlag = false;
            // self.$message.error(result.Message);
          }
        }, () => {
          self.$message.error('数据获取失败，请检查您的网络是否可用。');
        });
      },
      formatDuring(mss) {
        var days = parseInt(mss / (1000 * 60 * 60 * 24));
        var hours = parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = (mss % (1000 * 60)) / 1000;
        this.timeStr = hours+" 小时"+ minutes + " 分钟 " + Math.ceil(seconds) + " 秒 ";
        //return days + " 天 " + hours + " 小时 " + minutes + " 分钟 " + seconds + " 秒 ";
      },
      creatOrder(row){

        let self = this;
        self.loadingScreen = this.$loading({
          text: '订单信息提交中, 请勿刷新页面...',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.75)'
        });
        let params = {
          ProcessId:row.ProcessId,
          SalesUser:'',
          CustomNo:''
        }
        self.$http.post(self.url.creatOrder,{
          Data:params
        }).then(result =>{
          if(result.state == true){
            self.loadingScreen.close();
            var param = {
              type:self.IsStandard
            };
            param.id = [result.Data];
            sessionStorage.setItem('params',JSON.stringify(param))
            self.$router.push({
              path: '/PayOrder',
              name: 'PayOrder',
            })
          }else{
            self.$message.error(result.Message);
            self.loadingScreen.close();
          }
        }, () => {
          // self.tableLoading = false;
          self.loadingScreen.close();
          self.$message.error('获取数据失败，请检查您的网络是否可用。');
        });
      },
      getcuttent(){
        let self = this;
        self.$http.post(self.url.cuttent,{

        }).then(result =>{
          if(result.state == 1 && result.data){
            self.currentFWQTime = result.data;
          }else{
          }
        }, () => {
          self.$message.error('数据保存失败，请检查您的网络是否可用。');
        });
      },
      // connectServer() {
      //   var $this = this;
      //   var conn = $.hubConnection("http://localhost:10001", { });
      //   $this.proxy = conn.createHubProxy("NoticeHub");
      //   $this.getMsg();
      //   $this.getMsg1();
      //   conn.start().done((data) => {
      //     $this.sendMsg();
      //   }).fail((data) => {
      //   });
      // },
      // sendMsg() {
      //   var $this = this;
      //   $this.proxy.invoke("showMessage", 'sdsdsdsdsds').done((msg) => {
      //   });
      // },
      // getMsg() {
      //   var $this = this;
      //   $this.proxy.on("showMessage", (data) => {
      //     console.log(data)
      //     $this.showmsg = data;
      //   });
      //
      // },
      // getMsg1(){
      //   var $this = this;
      //   $this.proxy.on("receiveNotice", (data) => {
      //     console.log('receiveNotice');
      //     console.log(data)
      //   })
      // },

      connectServer() {
        var $this = this;
        // var conn = $.hubConnection(SZH.assets.ws, {qs:`scanKey=${this.uuid}`});
        var conn = $.hubConnection(SZH.assets.ws, {});
        $this.proxy = conn.createHubProxy("NoticeHub");
        $this.toGetMEs();
        conn.start().done((connection) => {
          // $this.sendMsg();
          $this.ClientId = connection.id;
        }).fail((data) => {
        });
      },
      toGetMEs() {
        var $this = this;
        $this.proxy.on("receiveNotice", (data) => {
          console.log(data)
          $this.mesRight = data;
          if(data){
            // $this.getMyList();
            $this.reLoad();
          }
        });

      },
    },
    destroyed(){
      clearInterval(this.timeInterval);
    },
    computed: {
      AllMoney(){
        return this.formBid.AuctionPrice == 0? 0:this.formBid.AuctionNum*this.formBid.AuctionPrice
      },
      ProductImg(){
        return SZH.assets.image + this.formRow.ProductImg
      }
    },
    components: {Template},
    mounted() {
      this.Id = this.$route.query.id;
      this.getMsg(this.$route.query.id);
      this.connectServer();
      this.getMyList();
      this.getCompany();
      this.refreshData();
      this.getcuttent();
      this.getCurrentList();
      // this.getMyListAll();
      if (document.hidden !== undefined) {
        document.addEventListener('visibilitychange', () => {
          if(document.hidden == true){
          }else{
            this.refreshData();
          }
        })
      }
    }
  }
</script>
<style>
  .table-sty .el-table__row td{
    padding: 12px 0px !important;
  }
  .tabs-box1 .el-tabs__content{
    padding: 20px;
  }

  .tabs-box .el-tabs__header .is-top{
    border: 0px;
  }
  .tabs-box .el-tabs--card>.el-tabs__header{
    border-bottom: 0px;
  }
  .tabs-box .el-tabs__item.is-active{
    color: white;
    background: #3458DE;
    /*background: #409EFF;*/
  }
  .tabs-box .el-tabs__item:hover{
    color: #000;
  }
  .tabs-box .el-tabs__item.is-active:hover{
    color: white;
  }
  .tabs-box1 .el-form-item__label{
    font-weight: 600;
  }
</style>
<style scoped>
  .my-position{
    padding: 30px 0px;
    position: relative;
    padding-left: 100px;
  }
  .youposition{
    position: absolute;
    left: 0px;
    top:50%;
    transform: translateY(-50%);
    font-size: 14px;
  }
  .bid-img-box{
    width: 298px;
    height: 298px;
    background: #D7D7D7;
    position: relative;
  }
  .bid-img-box img{
    width: 100%;
    height: 100%;
  }
  .bid-code{
    line-height: 300%;
    font-size: 14px;
  }
  .absolute-status{
    background: #919191;
    position: absolute;
    width: 100%;
    left: 0px;
    bottom: 0px;
  }
  .absolute-status p{
    font-size: 14px;
    font-weight: 600;
    color: white;
    line-height: 47px;
    text-align: center;
  }
  .bid-detail{
    width: 1200px;
    margin: 0px auto;
  }
  .bid-detail-info{
    width: 100%;
    background: white;
    padding: 0px 20px;
  }
  .bid-list ul.bid-list-ul{
    width: 100%;
  }
  .bid-list ul li{
    list-style: none;
    display: flex;
    align-items: center;
    padding: 0px 0px;
    position: relative;
  }
  .bin-info-title{
    display: flex;
    justify-content: left;
    align-items: center;
  }
  .bid-info{
    padding-left: 60px;
  }
  .bid-info img{
    width: 32px;
    height: 32px;
  }
  .bin-info-title{
    /*margin-bottom: 25px;*/
  }
  .bin-info-title span{
    display: inline-block;
    font-size: 18px;
    font-weight: 600;
    margin-left: 8px;
  }
  .bid-info p{
    color: #999999;
    margin: 12px 0px;
  }
  .bid-info p i{
    font-size: 18px;
    font-weight: 600;
    margin-left: 5px;
  }
  .join-button{
    border: 0px;
    padding: 10px 40px;
    background: #3458DE;
    color: white;
    cursor: pointer;
    margin-top: 15px;
  }
  .bid-info p span.span-label{
    width: 75px;
    text-align: left;
    display: inline-block;
    font-size: 14px;
  }
  .bid-info p span.span-value{
    font-weight: 600;
    font-size: 14px;
  }
  .bid-button-father{
    width: 500px;position: relative;
    padding-left: 20px;
  }
  .bid-button{
    border: 0px;
    color: #7F93CD;
    position: absolute;
    bottom: 55px;
    right: 50px;
    cursor: pointer;
  }
  .bid-button-top{
    border: 0px;
    color: #7F93CD;
    position: absolute;
    top: 20px;
    right: 10px;
    cursor: pointer;
  }
  .max-min p{
    font-size: 16px;
    font-weight: 600;
    text-align: right;
    color: #999999;
    line-height: 150%;
  }
  .max-min p.max-money span{
    color:#3458DE;
  }
  .max-min p.min-money span{
    color:#0066FF;
  }
  .bid-tabs{
    margin-top: 20px;
    padding: 0px 0px;
    background: white;
  }
  .all-bid{
    padding: 20px;
    padding-bottom: 50px;
  }
  .bid-process{
    background: #f5f5f5;
    border-top: 30px solid #f5f5f5;
  }
  .bid-process .bg{

    background: #F2F2F2;
    padding: 15px 0px;
  }
  .bid-process .bg:hover{
    background: #3458DE;
    color: white;
    transition: all 0.6s;
  }
  .bid-process .bg p{
    font-size: 16px;
    text-align: center;
    font-weight: 600;
    line-height: 200%;
  }
  .dialog-form-display span.s-value{
    color: #990033;
  }
  .inputaddsty input:focus{
    border: 0px;
    color: white;
  }
  .title-p{
    text-align: center;
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 20px;
  }
  .info-box span{
    border-bottom: 1px solid #ddd;
    padding: 5px 0px;
  }
  .info-flex{
    display: flex;
    margin: 5px 0px;
  }
  .info-flex >p{
    width: 60px;
    text-align: left;
    padding: 5px 0px;
  }
  .info-flex span{
    flex: 1;
  }
  .detail-head{
    display: flex;
  }
  .detail-head>div{
    flex: 1;
    border: 1px solid #ddd;
    padding: 5px;
  }
  .detail-body{
    display: flex;
  }
  .detail-body>div{
    flex: 1;
    border: 1px solid #ddd;
    padding: 5px;
  }
  .successStatus{
    background: #F56C6C;
  }
</style>



// WEBPACK FOOTER //
// src/views/BidBuyDetail/BidBuyDetail.vue